<ng-container *ngIf="isVisible">
  <!-- Linguetta Laterale (Right Edge Side-Tab) -->
  <div class="qa-side-tab" (click)="isOpen = !isOpen" style="z-index: 9992;">
    <ion-icon name="bug"></ion-icon>
  </div>

  <!-- QA reporting panel overlay -->
  <div class="qa-panel-backdrop" *ngIf="isOpen" (click)="isOpen = false"></div>
  
  <div class="qa-panel" *ngIf="isOpen">
    <div class="qa-header">
      <h2 class="qa-title">Segnala Bug Beta</h2>
      <ion-button fill="clear" size="small" (click)="isOpen = false" class="qa-close-btn">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </div>

    <div class="qa-body">
      <ion-list>
        <ion-item>
          <ion-label position="stacked">Caso di Test Associato</ion-label>
          <ion-select [(ngModel)]="selectedTestCase" okText="Conferma" cancelText="Annulla">
            <ion-select-option value="GENERICO">Generico / Nessuno</ion-select-option>
            
            <ion-select-optgroup label="BC1: Prenotazioni Visuali">
              <ion-select-option value="TC-BC1-01">TC-BC1-01 (Mappa AM/PM)</ion-select-option>
              <ion-select-option value="TC-BC1-02">TC-BC1-02 (Modalità Accessibile)</ion-select-option>
              <ion-select-option value="TC-BC1-03">TC-BC1-03 (Conto Terzi)</ion-select-option>
              <ion-select-option value="TC-BC1-04">TC-BC1-04 (Conflitto Orario)</ion-select-option>
              <ion-select-option value="TC-BC1-05">TC-BC1-05 (Capienza Sale)</ion-select-option>
              <ion-select-option value="TC-BC1-06">TC-BC1-06 (Filtri Funzione)</ion-select-option>
              <ion-select-option value="TC-BC1-07">TC-BC1-07 (Lock Uffici)</ion-select-option>
            </ion-select-optgroup>
            
            <ion-select-optgroup label="BC2: Sicurezza e Presidio">
              <ion-select-option value="TC-BC2-01">TC-BC2-01 (Blocco Sede)</ion-select-option>
              <ion-select-option value="TC-BC2-02">TC-BC2-02 (Sblocco Presidio)</ion-select-option>
              <ion-select-option value="TC-BC2-03">TC-BC2-03 (Canc. Cascata)</ion-select-option>
              <ion-select-option value="TC-BC2-04">TC-BC2-04 (Bypass HR)</ion-select-option>
              <ion-select-option value="TC-BC2-05">TC-BC2-05 (Sicurezza Non Unica)</ion-select-option>
            </ion-select-optgroup>

            <ion-select-optgroup label="BC3: Eventi Aziendali">
              <ion-select-option value="TC-BC3-01">TC-BC3-01 (Richiesta Partecipazione)</ion-select-option>
              <ion-select-option value="TC-BC3-02">TC-BC3-02 (Approvazione HR)</ion-select-option>
              <ion-select-option value="TC-BC3-03">TC-BC3-03 (Pianificazione HR)</ion-select-option>
              <ion-select-option value="TC-BC3-04">TC-BC3-04 (Annullamento USER)</ion-select-option>
            </ion-select-optgroup>

            <ion-select-optgroup label="BC4: Personalizzazione e Notifiche">
              <ion-select-option value="TC-BC4-01">TC-BC4-01 (Preferiti)</ion-select-option>
              <ion-select-option value="TC-BC4-02">TC-BC4-02 (Sede Preferita)</ion-select-option>
              <ion-select-option value="TC-BC4-03">TC-BC4-03 (Notifiche In-App)</ion-select-option>
              <ion-select-option value="TC-BC4-04">TC-BC4-04 (Notifiche E-mail)</ion-select-option>
            </ion-select-optgroup>

            <ion-select-optgroup label="BC5: Analytics">
              <ion-select-option value="TC-BC5-01">TC-BC5-01 (Export CSV)</ion-select-option>
              <ion-select-option value="TC-BC5-02">TC-BC5-02 (Blocco USER)</ion-select-option>
            </ion-select-optgroup>

            <ion-select-optgroup label="BC6: JIRA Consuntivazione">
              <ion-select-option value="TC-BC6-01">TC-BC6-01 (Export Jarvis)</ion-select-option>
              <ion-select-option value="TC-BC6-02">TC-BC6-02 (Blocco USER)</ion-select-option>
              <ion-select-option value="TC-BC6-03">TC-BC6-03 (Motore Diagnostico)</ion-select-option>
            </ion-select-optgroup>
          </ion-select>
        </ion-item>

        <ion-item class="ion-margin-top">
          <ion-label position="stacked">Descrizione Bug Riscontrato</ion-label>
          <ion-textarea [(ngModel)]="bugDescription" 
                        placeholder="Spiega brevemente cosa non funziona e come riprodurlo..." 
                        rows="4" 
                        required></ion-textarea>
        </ion-item>

        <!-- Replay & Diagnostics status card -->
        <div style="background: rgba(var(--ion-color-danger-rgb, 235, 68, 90), 0.08); border-radius: 8px; border: 1px solid rgba(var(--ion-color-danger-rgb, 235, 68, 90), 0.25); padding: 10px 12px; margin-top: 14px;">
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <span style="display: inline-block; width: 10px; height: 10px; border-radius: 50%; background: #e02424; animation: pulse 1.5s infinite;"></span>
              <span style="font-size: 0.85rem; font-weight: 600; color: var(--ion-color-dark);">Replay & Console Buffer</span>
            </div>
            <ion-badge color="danger" mode="ios" style="font-size: 0.75rem;">{{ replayDuration }}s ({{ replayEventCount }} ev)</ion-badge>
          </div>
          <p style="font-size: 0.75rem; color: var(--ion-color-medium); margin: 6px 0 10px 0; line-height: 1.3;">
            Gli ultimi {{ replayDuration }} secondi di interazioni (click, navigazioni) e gli errori di console vengono inclusi nel ticket per la diagnosi rapida.
          </p>
          <ion-item lines="none" style="--min-height: 32px; --background: transparent; padding: 0;">
            <ion-checkbox slot="start" [(ngModel)]="includeReplay" mode="ios" style="margin-right: 10px;"></ion-checkbox>
            <ion-label style="font-size: 0.8rem; margin: 0;">Includi Replay e Log di Console</ion-label>
          </ion-item>
        </div>
      </ion-list>

      <ion-button expand="block" color="danger" class="ion-margin-top"
                  [disabled]="bugDescription.length < 10 || sending" (click)="inviaSegnalazione()">
        <span *ngIf="!sending">Invia a Jira / Jarvis</span>
        <ion-spinner name="crescent" *ngIf="sending"></ion-spinner>
      </ion-button>
    </div>
  </div>
</ng-container>
